import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { Form, Input, Modal } from "@samskip/frontend-components";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import * as yup from "yup";

import { LabelConstants } from "@assets/constants";
import { useAppDispatch, useAppSelector } from "@assets/hooks";
import { LoginState } from "@assets/types";
import { getErrorMessage } from "@assets/utilities/translateUtilities";
import {
  closePasswordModal,
  login,
  logout,
  userProfileState,
} from "@state/slices/userProfileSlice";

interface PasswordForm {
  Password: string;
}

const defaultFormValues: PasswordForm = {
  Password: "",
};

const schema = yup.object({
  Password: yup.string().required(LabelConstants.ERROR_LABELS.REQUIRED_FIELD),
});

const PasswordModal = () => {
  const { t } = useTranslation();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const isOpen = useAppSelector(userProfileState).isPasswordModalOpen;
  const userProfile = useAppSelector(userProfileState).userProfile;
  const isLoggingIn = useAppSelector(userProfileState).loginInProgress;
  const dispatch = useAppDispatch();

  const {
    formState: { errors },
    handleSubmit,
    register,
    reset,
  } = useForm({
    defaultValues: defaultFormValues,
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const closeModal = () => {
    dispatch(closePasswordModal());
    // setIsModalOpen(false);
  };

  const handleLogin = async (data: PasswordForm) => {
    if (userProfile && !isLoggingIn) {
      const loginState: LoginState = {
        username: userProfile?.Access.LoginID,
        password: data.Password,
      };
      try {
        await dispatch(login(loginState)).unwrap();
        closeModal();
        reset();
      } catch (err) {
        toast.error(`Fetch failed: ${err.message}`);
      }
    }
  };

  const handleLogout = () => {
    if (userProfile) {
      dispatch(logout(userProfile.Access)).then(() => {
        closeModal();
        reset();
      });
    }
  };

  return (
    <Modal
      open={isOpen}
      primaryButtonProps={{
        loading: isLoggingIn,
        onClick: handleSubmit(handleLogin),
        type: "submit",
        children: t("TEXT_LOGIN"),
      }}
      secondaryButtonProps={{
        onClick: handleLogout,
        children: t("TEXT_LOGOUT"),
      }}
      size="small"
      title={t("LABEL_LOGIN")}
    >
      <Form onSubmit={handleSubmit(handleLogin)}>
        <p>{t("TEXT_SESSION_EXPIRED")}</p>
        <Input
          errorMessage={getErrorMessage("Password", errors)}
          fullWidth
          hasError={errors.Password != null}
          id="password"
          placeholder={t("LABEL_PASSWORD")}
          type="password"
          {...register("Password")}
        />
      </Form>
    </Modal>
  );
};

export default PasswordModal;
